/*
 * Candidate Additional Fields Tab Messages
 *
 * This contains all the text for the Candidate Additional Fields Tab component.
 */

import { defineMessages } from 'react-intl';
export const scope =
  'src.pages.CandidatesDetailsPage.components.CandidateAdditionalFieldsTab';

export default defineMessages({
  title: { id: `${scope}.title`, defaultMessage: 'Attributes' },
  editTitle: { id: `${scope}.editTitle`, defaultMessage: 'Editing' },
  editButton: { id: `${scope}.editButton`, defaultMessage: 'Edit' },
  cancelButton: { id: `${scope}.cancelButton`, defaultMessage: 'Cancel' },
  saveButton: { id: `${scope}.saveButton`, defaultMessage: 'Save' },
  yesLabel: { id: `${scope}.yesLabel`, defaultMessage: 'Yes' },
  noLabel: { id: `${scope}.noLabel`, defaultMessage: 'No' },
  notVisibleByUserLabel: {
    id: `${scope}.notVisibleByUserLabel`,
    defaultMessage: '(only visible by ucm)',
  },
});
